import { useNavigate } from "react-router-dom";
import { fmtDate, inr } from "@/lib/api";
import { useApi, Panel, StatusBadge } from "@/crm/ui";

const cols = (nav) => [
  { key: "enquiry_id", label: "ID" },
  { key: "customer_name", label: "Customer" },
  { key: "loan_amount", label: "Amount", render: (r) => inr(r.loan_amount) },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "created_at", label: "Created", render: (r) => fmtDate(r.created_at) },
];

const MiniTable = ({ rows, empty, nav, testid }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm" data-testid={testid}>
      <tbody>
        {(rows || []).slice(0, 6).map((r, i) => (
          <tr key={r.enquiry_id} onClick={() => nav("/crm/enquiries")}
              className="cursor-pointer border-b border-border/60 hover:bg-muted/40"
              data-testid={`${testid}-row-${i}`}>
            {cols(nav).map((c) => (
              <td key={c.key} className="max-w-[160px] truncate px-2 py-2">
                {c.render ? c.render(r) : (r[c.key] ?? "—")}</td>
            ))}
          </tr>
        ))}
        {(!rows || rows.length === 0) && (
          <tr><td className="px-2 py-6 text-center text-sm text-muted-foreground">{empty}</td></tr>
        )}
      </tbody>
    </table>
  </div>
);

export default function EnquiriesDashboardWidget() {
  const nav = useNavigate();
  const d = useApi("/crm/enquiries/dashboard");
  const data = d.data || {};
  const counts = data.counts || {};
  const hasTeam = (data.team || []).length > 0;

  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid="enquiries-dashboard-widget">
      <Panel title={`My assigned enquiries (${counts.mine ?? 0})`} testid="my-enquiries-panel"
             aside={<span className="text-xs text-muted-foreground">{counts.mine_open ?? 0} open</span>}>
        <MiniTable rows={data.mine} nav={nav} testid="my-enquiries-table"
                   empty="No enquiries assigned to you yet." />
      </Panel>
      {hasTeam && (
        <Panel title={`Team enquiries (${counts.team ?? 0})`} testid="team-enquiries-panel"
               aside={<span className="text-xs text-muted-foreground">Your reports</span>}>
          <MiniTable rows={data.team} nav={nav} testid="team-enquiries-table"
                     empty="No enquiries assigned to your team." />
        </Panel>
      )}
    </div>
  );
}
